// extracted by mini-css-extract-plugin
export default {"appBanner":"app-banner_appBanner__iBxhm","yellow":"app-banner_yellow__HmPda","lightBlue":"app-banner_lightBlue__y7D2f"};